import { Language, Lightning, Router, Storage } from "@lightningjs/sdk";
import { SettingsCarouselItem } from "../layout/SettingsCarouselItem";
import { getHomePage, STORAGE_KEYS } from "../../../../../lib/utils";

interface SettingsLanguageTemplateSpec extends Lightning.Component.TemplateSpec {
    Layout: typeof SettingsCarouselItem;
}

export class SettingsLanguage
    extends Lightning.Component<SettingsLanguageTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SettingsLanguageTemplateSpec>
{
    readonly SettingsItem = this.getByRef("Layout")!;

    static override _template(): Lightning.Component.Template<SettingsLanguageTemplateSpec> {
        return {
            collision: true,
            zIndex: 10,
            Layout: {
                type: SettingsCarouselItem,
                title: "general.language"
            }
        };
    }

    override _getFocused() {
        return this.SettingsItem;
    }

    override _setup() {
        const options = Language.available();

        const selected = options.find((option: { code: string; name: string }) => option.code === Language.get());

        this.SettingsItem.patch({
            selectedOption: selected.code,
            options: options,
            valueKey: "code",
            labelKey: "name"
        });
    }

    $optionSelected(code: string) {
        const selected = Language.available().find((lang: any) => lang.code === code);

        this.SettingsItem.patch({
            selectedOption: selected.code
        });

        code = selected?.code || "en";
        Language.set(code)
            .then(() => {
                this.application.emit("appLanguageChanged");
                Storage.set(STORAGE_KEYS.selectedLanguage, code);
            })
            .catch();

        // to refetch content as it might differ from language
        Router.deletePage(getHomePage());
    }

    _handleHover() {
        this.fireAncestors("$listItemHover", this);
        this.SettingsItem.focusList();
    }
}
